/**
 * Single source of truth for all file upload limits.
 *
 * Used by: server (multer middleware, post-photo route), client (list page).
 */

/**
 * Global hard ceiling for any uploaded file across all endpoints.
 * Enforced by the multer fileUploader middleware. Per-route limits
 * (e.g. MAX_PDF_SIZE_BYTES) are no stricter than this and are enforced in the
 * route handler so the caller gets a format-specific error message.
 */
export const MAX_UPLOAD_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB

/** Maximum allowed PDF file size. PDFs exceeding this are rejected before processing. */
export const MAX_PDF_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB

/** Maximum number of pages allowed in an uploaded PDF. */
export const MAX_PDF_PAGES = 5;

/** Minimum character count for extracted PDF text to be considered meaningful (vs. scanned/image-only). */
export const MIN_MEANINGFUL_TEXT_LENGTH = 30;

/**
 * Maximum characters accepted for a hand-entered list (POST /api/list/text).
 * Enforced by the textarea's maxLength on the client and re-validated on the
 * server. The item cap (200) still applies
 * to the result — extractItemsFromText's prompt also caps the item count it
 * asks the model for, so a long list doesn't produce more items than the
 * extraction token budget can hold.
 */
export const MAX_LIST_TEXT_LENGTH = 10000;

/**
 * Minimum non-whitespace characters required for a hand-entered list. Counted
 * with whitespace stripped out, so line breaks between items don't count
 * toward the minimum. Below this there usually isn't enough for the model to
 * extract a real item from. Enforced on both the client and the server.
 */
export const MIN_LIST_TEXT_LENGTH = 20;

/** Maximum allowed image file size for the list-to-order upload. */
export const MAX_IMAGE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB
